import DocumentListPanel from 'Components/Generic/Documents/DocumentListPanel';
import DocumentData from 'Data/DocumentData';
import TransactionDocumentData from 'Data/TransactionDocumentData';
import PropTypes from 'prop-types';

const TransactionDocumentsPanel = ({ transaction = {}, ...props }) => {
  return (
    <DocumentListPanel
      documentType={'Transaction'}
      documents={transaction?.documents}
      associatedDocuments={transaction?.request?.documents}
      uploadDocFunc={(file) =>
        DocumentData.uploadTransactionDocument(file, transaction?.id)
      }
      deleteDocFunc={(docObj) =>
        TransactionDocumentData.deleteDocument(docObj, transaction?.id)
      }
      docJoinTableData={TransactionDocumentData}
      {...props}
    />
  );
};

TransactionDocumentsPanel.propTypes = {
  transaction: PropTypes.object.isRequired,
  editable: PropTypes.bool,
  canAddDoc: PropTypes.bool,
  disabled: PropTypes.bool,
  onDocumentsUpdated: PropTypes.func,
};

export default TransactionDocumentsPanel;
